import { render, staticRenderFns } from "./IndividualScore.vue?vue&type=template&id=f2f9b6bc&scoped=true&"
import script from "./IndividualScore.vue?vue&type=script&lang=js&"
export * from "./IndividualScore.vue?vue&type=script&lang=js&"
import style0 from "./IndividualScore.vue?vue&type=style&index=0&id=f2f9b6bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f9b6bc",
  null
  
)

export default component.exports